import Vue from 'vue';
import dom from "./resize.directive";
import permission from "./permission.directive";
import time from "./time.filter";

function loadExtends(app) {
    Vue.directive("resize", dom.resize);
    Vue.directive("permission", permission.perm);
    Vue.filter("time", time.formatDate);
}

export default {
    loadExtends
}

